export default function getAgeLabel(age) {
	if (age) {
		const monthsLabel = age.months ? ` og ${age.months} mnd` : '';
		return `${age.years} år${monthsLabel}`;
	}

	return null;
}
